import { Assessment, AssignmentOutlined, Delete, Edit, FormatListBulleted, PictureAsPdf } from '@mui/icons-material';
import { ICellRendererParams } from 'ag-grid-community';
import { useLocation, useNavigate } from 'react-router-dom';
import { Module } from 'src/domain';
import { useIsAdmin } from 'src/hooks/auth/useIsAdmin';
import { ActionsCellRenderer } from '../ActionsCellRenderer/ActionsCellRenderer';

export const SalesCampaignsActionsRenderer = (params: ICellRendererParams) => {
    const location = useLocation();
    const navigate = useNavigate();
    const isAdmin = useIsAdmin();
    const {
        handleEdit,
        showDeleteDialog,
        handleShowDownloadDialog,
        handleShowMonitorDownloadDialog,
        isMonitorReportAvailable,
    } = params.context;
    const row = params.data;
    const monitorReportAvailable = isMonitorReportAvailable(row);

    return (
        <ActionsCellRenderer
            actions={[
                {
                    icon: <FormatListBulleted color="primary" />,
                    title: 'Manage campaign items',
                    testId: `showButton-${row.id}`,
                    onClick: () => navigate(`/${Module.SalesCampaignsPlanning}/${row.id}${location.search}`),
                },
                {
                    icon: <Assessment color="primary" />,
                    title: 'Show sales summary report',
                    testId: `reportButton-${row.id}`,
                    onClick: () => navigate(`/${Module.SalesCampaignsReport}/${row.id}${location.search}`),
                },
                {
                    icon: <AssignmentOutlined color="primary" />,
                    title: 'Download store campaign briefing',
                    testId: `downloadButton-${row.id}`,
                    onClick: () => handleShowDownloadDialog(row.id),
                },
                ...(isAdmin
                    ? [
                          {
                              icon: <PictureAsPdf color={monitorReportAvailable ? 'primary' : 'disabled'} />,
                              title: monitorReportAvailable
                                  ? 'Download latest week performance'
                                  : 'Latest week performance is only available for active or recently ended campaigns',
                              testId: `monitorDownloadButton-${row.id}`,
                              onClick: () => handleShowMonitorDownloadDialog(row.id),
                              disabled: !monitorReportAvailable,
                          },
                      ]
                    : []),
                {
                    icon: <Edit color="info" />,
                    title: 'Edit campaign details',
                    testId: `editButton-${row.id}`,
                    onClick: () => handleEdit(row),
                },
                {
                    icon: <Delete color="error" />,
                    title: 'Delete campaign',
                    testId: `deleteButton-${row.id}`,
                    onClick: () => showDeleteDialog(row),
                },
            ]}
        />
    );
};
